import templateUrl from '../../transportation-alternative-list-template1.html';

export const ridesharingListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},

	templateUrl,

	controller: class RidesharingListComponent {
		constructor($state, toastr, ApiService, ModalService, TransportationAlternativeService, DashboardService, DynamicMenusService, SlugService) {
			'ngInject';

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dashboardService = DashboardService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		$onInit() {
			this.details = this.transportationAlternativeService.getRidesharingDetails(this.details);
			this.activeMenuName = this.dashboardService.getActiveMenuName();
			this.pageTitle = `${this.activeMenuName} List`;

			this.currentPage = 1;
			this.itemPerPage = 10;
			this.totalItems = this.details.count;
			this.filterDetails = {
				'limit': this.itemPerPage,
				'page_id': this.currentPage
			};
			this.showPagination = true;
		}

		routeDetailsPageUrl(slug) {
			const url = this.slugService.getDetailsPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		routeEditPageUrl(slug) {
			const url = this.slugService.getEditPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		_getImage(detail) {
			const image = detail.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
		}

		routeAddPageUrl() {
			const url = this.slugService.getAddPageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}

		onChange(pageNumber) {
			this.currentPage = pageNumber;
			this.filterDetails.limit = this.itemPerPage;
			this.filterDetails.page_id = this.currentPage;
			this.transportationAlternativeService.getRidesharingDetailsByFilter(this.filterDetails, this.slugUrl)
				.then((result) => {
					this.details.list = result.list;
				});
		}

		//on delete the call for help data
		onDelete(slug) {
			this.modalService.open({
				details: {
					bodyMessage: 'Are you sure you want to delete the data?'
				},

				buttons: [
					{
						name: 'No'
					},
					{
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}
				]
			});

			function onSubmit() {
				this.dynamicMenusService.deleteMenuDetailsByUrl(`${slug}/delete`)
					.then((response) => {
						this.totalItems -= 1;
						this.toastr.success("Data Deleted successfully");
					})
					.then(_ => this.transportationAlternativeService.getRidesharingDetailsByFilter(this.filterDetails, this.slugUrl))
					.then(({ list }) => {
						this.details.list = list;
					})
					.catch((err) => {
						this.toastr.error(err);
					});
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/ridesharing/ridesharing-list/ridesharing-list.component.js